import { Component, ViewChild, Input, Output, EventEmitter, inject } from '@angular/core';

import { HisAuthService, HisSearchResultComponent, HisSearchSelectionSetting } from 'hisng';

@Component( {
    selector: 'psv-person-id-assignment-search-result',
    templateUrl: './person-id-assignment-search-result.component.html',
    standalone: false
} )
export class PersonIdAssignmentSearchResultComponent {
    auth = inject(HisAuthService);

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;
    readonly SEARCH_CONFIG_PUBLICATION_ORCID_USER = '';
    protected readonly selectionSetting = HisSearchSelectionSetting;
    @Output() changeSearch = new EventEmitter();
    @Output() newSearch = new EventEmitter();
    @Output() doImport = new EventEmitter();
    @Input() set search(search: any) {
        if (search) {
            this.searchResultComponent.loadPage(0, search);
            this.searchResultComponent.genericSearchRowTooltipId = 'CONCAT2([Person].firstname,\' \',[Person].surname,'
                + '\' \',[Person].[Orgunit]:Orgunit{REVERSEPATH=versionedObj}.defaulttext,\' \',PersonOrcidImportItem.orcid)';
        }
    }

    onNewSearch() {
        this.newSearch.emit();
    }

    onChangeSearch() {
        this.changeSearch.emit();
    }

    onDoImport() {
        this.doImport.emit({ search: this.searchResultComponent.search, selectedOptions: this.searchResultComponent.selectedOptions });
    }
}
